module.exports = __webpack_public_path__ + "img/bank-accounts.ece99ca6.svg";